import queryString from "query-string"

import { Location } from "@life-without-barriers/gatsby-common"

export const queryFromLocation = (location: Location): string | undefined => {
  if (!location.search) {
    return undefined
  }
  const parsedSearch = queryString.parse(location.search)
  if (parsedSearch.query) {
    if (Array.isArray(parsedSearch.query)) {
      return undefined
    }
    return parsedSearch.query
  }
}

export const toSearchQuery = (query: string) =>
  `${queryString.stringify({ query })}`
